// extracted by mini-css-extract-plugin
export var button = "_no-2";
export var card = "_no-0";
export var closeButtonContainer = "_no-3";
export var iconContainer = "_no-1";